// extracted by mini-css-extract-plugin
module.exports = {"idealNutritionalBlock":"IdealNutritionBalanceSection_idealNutritionalBlock__9Y2Y5","description":"IdealNutritionBalanceSection_description__u8xSl"};